import React, { ReactElement } from "react";
import styled, { keyframes } from "styled-components";

import kast from "../../assets/intro-last-frame-transparent.webp";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  
  100% {
    opacity: 1;
  }
`;
const Kast = styled.img`
  object-fit: contain;
  object-position: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  animation: ${fadeIn} 0.2s;
`;

const IntroLastFrame = (): ReactElement => (
  <Kast src={kast} alt="Decor met kast" />
);

export default IntroLastFrame;
